export default "__VITE_ASSET__C7zE0jeQ__"